/** Short on-canvas caption ("Undo", "Cut out"). Bubbles from any element inside a pane to its BoardPane. */
export const FLASH_EVENT = 'vds:flash';

export function flash(from: Element, text: string): void {
  from.dispatchEvent(new CustomEvent<string>(FLASH_EVENT, { bubbles: true, detail: text }));
}
